import app from './app'

export default {
  name: 'AUTHORIZED_APPS',
  actions: [
    app.CREATE_AUTHORIZED_APP,
  ],
}
